<template>
  <div class="info-box">
    <div class="head-box">
      <div class="title-box">
        <p
          :class="{ sel: dataShow === 'current' }"
          @click="typeChange('current')"
        >
          {{ $t("order_manage.current_delegation") }}
        </p>
        <p
          :class="{ sel: dataShow === 'history' }"
          @click="typeChange('history')"
        >
          {{ $t("order_manage.history_delegation") }}
        </p>
      </div>
      <div class="btn-box" v-if="dataShow === 'current'">
        <div class="btn-type1">
          <el-input
            class="width-s"
            v-model="currentFilter.coinSymbol"
            :placeholder="$t('order_manage.coin_type')"
          />
          -
          <el-select v-model="currentFilter.baseSymbol" class="width-s">
            <el-option :key="'all'" :label="$t('order_manage.all')" :value="''">
            </el-option>
            <el-option
              v-for="item in symbolList"
              :key="item.baseSymbol"
              :label="item.baseSymbol"
              :value="item.baseSymbol"
            >
            </el-option>
          </el-select>
        </div>
        <el-select v-model="currentFilter.direction" class="width-s">
          <el-option
            :key="'all'"
            :label="$t('order_manage.all_direction')"
            :value="''"
          ></el-option>
          <el-option
            :key="'buy'"
            :label="$t('order_manage.buy')"
            :value="'buy'"
          ></el-option>
          <el-option
            :key="'sell'"
            :label="$t('order_manage.sell')"
            :value="'sell'"
          ></el-option>
        </el-select>
        <div class="btn" @click="getSearchCurrentDelegation">
          {{ $t("order_manage.search") }}
        </div>
      </div>
      <div class="btn-box" v-if="dataShow === 'history'">
        <div class="btn-type1">
          <el-date-picker
            class="width-s2"
            v-model="historyFilter.timeFilter"
            value-format="yyyy-MM-dd"
            type="daterange"
            :start-placeholder="$t('order_manage.time_start')"
            :end-placeholder="$t('order_manage.time_end')"
          >
          </el-date-picker>
          <el-input
            class="width-s"
            v-model="historyFilter.coinSymbol"
            :placeholder="$t('order_manage.coin_type')"
          />
          -
          <el-select v-model="historyFilter.baseSymbol" class="width-s">
            <el-option :key="'all'" :label="$t('order_manage.all')" :value="''">
            </el-option>
            <el-option
              v-for="item in symbolList"
              :key="item.baseSymbol"
              :label="item.baseSymbol"
              :value="item.baseSymbol"
            >
            </el-option>
          </el-select>
        </div>
        <el-select v-model="historyFilter.direction" class="width-s">
          <el-option
            :key="'all'"
            :label="$t('order_manage.all_direction')"
            :value="''"
          ></el-option>
          <el-option
            :key="'buy'"
            :label="$t('order_manage.buy')"
            :value="'buy'"
          ></el-option>
          <el-option
            :key="'sell'"
            :label="$t('order_manage.sell')"
            :value="'sell'"
          ></el-option>
        </el-select>
        <div class="btn" @click="getSearchHistoryDelegation">
          {{ $t("order_manage.search") }}
        </div>
      </div>
    </div>
    <div class="box2 c-flex1 c-flex-column" v-show="dataShow === 'current'">
      <NoData v-if="current_delegation.length <= 0" />
      <el-table
        v-else
        ref="current_table"
        :data="current_delegation"
        style="width: 100%"
        header-cell-class-name="table-head"
        cell-class-name="table-cell"
        v-loading="loading1"
      >
        <el-table-column
          prop="time"
          :label="$t('order_manage.time')"
          width="180"
        >
          <template slot-scope="scope">
            {{ dateFormatter(new Date(scope.row.time), "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="symbol"
          :label="$t('order_manage.symbol')"
          width="130"
        >
        </el-table-column>
        <el-table-column :label="$t('order_manage.way')" width="70">
          <template slot-scope="scope">
            <label v-if="scope.row.typeStr === 'LIMIT_PRICE'">
              {{ $t("order_manage.limit") }}
            </label>
          </template>
        </el-table-column>
        <el-table-column :label="$t('order_manage.direction')" width="70">
          <template slot-scope="scope">
            <label v-if="scope.row.directionStr === 'BUY'">
              {{ $t("order_manage.buy") }}
            </label>
            <label v-if="scope.row.directionStr === 'SELL'">
              {{ $t("order_manage.sell") }}
            </label>
          </template>
        </el-table-column>
        <el-table-column prop="price" :label="$t('order_manage.price')">
        </el-table-column>
        <el-table-column prop="amount" :label="$t('order_manage.amount')">
        </el-table-column>
        <el-table-column prop="total" :label="$t('order_manage.total')">
          <template slot-scope="scope">
            {{ getFloorNum(scope.row.price * scope.row.amount, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="turnover"
          :label="$t('order_manage.deal_concluded')"
        >
        </el-table-column>
        <el-table-column :label="$t('order_manage.operation')" width="160">
          <template slot-scope="scope">
            <label
              class="font_color_red"
              v-if="scope.row.statusStr === 'CANCELING'"
            >
              {{ $t("trade_ctc.delegationTable.canceling") }}
            </label>
            <template v-else>
              <label
                style="cursor: pointer; user-select: none"
                class="font_color_green"
                @click="orderCancel(scope.row)"
              >
                {{ $t("order_manage.cancel") }}
              </label>
              <label
                v-if="scope.row.turnover > 0"
                style="cursor: pointer; user-select: none"
                class="font_color_green ml10"
                @click.stop="openExpandCurrent(scope.row)"
              >
                {{ $t("order_manage.detail") }}
              </label>
            </template>
          </template>
        </el-table-column>
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <div class="expand-wrap">
              <div class="clear" style="margin-bottom: 30px">
                <div class="tag">
                  {{ $t("order_manage.order_id") }}
                  <span class="ml20">{{ scope.row.orderId }}</span>
                </div>
              </div>
              <div class="flex-wrap">
                <aside class="tag">{{ $t("order_manage.time") }}</aside>
                <aside class="tag">{{ $t("order_manage.done_price") }}</aside>
                <aside class="tag">{{ $t("order_manage.done_amount") }}</aside>
                <aside class="tag">{{ $t("order_manage.fee") }}</aside>
                <aside class="tag">{{ $t("order_manage.dk") }}</aside>
              </div>
              <div class="flex-wrap" v-for="item in scope.row.orderList">
                <section>
                  {{
                    dateFormatter(new Date(item.time), "yyyy-MM-dd hh:mm:ss")
                  }}
                </section>
                <section>{{ item.price }}</section>
                <section>{{ item.amount }}</section>
                <section>{{ item.payFee }}</section>
                <section>{{ item.payDk }}</section>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="currentTotal > 0"
        class="pagination-box"
        background
        layout="prev, pager, next"
        :total="currentTotal"
        :page-size="currentFilter.pageSize"
        :current-page="currentFilter.needPage"
        @current-change="pageChange"
      />
    </div>
    <div class="box2 c-flex1 c-flex-column" v-show="dataShow === 'history'">
      <NoData v-if="history_delegation.length <= 0" />
      <el-table
        v-else
        ref="history_table"
        :data="history_delegation"
        style="width: 100%"
        header-cell-class-name="table-head"
        cell-class-name="table-cell"
        v-loading="loading2"
      >
        <el-table-column
          prop="time"
          :label="$t('order_manage.time')"
          width="180"
        >
          <template slot-scope="scope">
            {{ dateFormatter(new Date(scope.row.time), "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="symbol"
          :label="$t('order_manage.symbol')"
          width="130"
        >
        </el-table-column>
        <el-table-column
          prop="typeStr"
          :label="$t('order_manage.way')"
          width="70"
        >
          <template slot-scope="scope">
            <label v-if="scope.row.typeStr === 'LIMIT_PRICE'">
              {{ $t("order_manage.limit") }}
            </label>
          </template>
        </el-table-column>
        <el-table-column :label="$t('order_manage.direction')" width="70">
          <template slot-scope="scope">
            <label v-if="scope.row.directionStr === 'BUY'">
              {{ $t("order_manage.buy") }}
            </label>
            <label v-if="scope.row.directionStr === 'SELL'">
              {{ $t("order_manage.sell") }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          width="130"
          prop="price"
          :label="$t('order_manage.price')"
        >
        </el-table-column>
        <el-table-column prop="amount" :label="$t('order_manage.amount')">
        </el-table-column>
        <el-table-column :label="$t('order_manage.dk')">
          <template slot-scope="scope">
            {{ scope.row.dk > 0 ? scope.row.dk : "--" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tradedAmount"
          :label="$t('order_manage.deal_concluded')"
        >
        </el-table-column>
        <el-table-column width="100" :label="$t('order_manage.status')">
          <template slot-scope="scope">
            <label v-if="scope.row.statusStr === 'COMPLETED'">
              {{ $t("trade_ctc.delegationTable.completed") }}
            </label>
            <label v-else-if="scope.row.turnover > 0">
              {{ $t("trade_ctc.delegationTable.part_completed") }}
            </label>
            <label v-else>
              {{ $t("trade_ctc.delegationTable.canceled") }}
            </label>
          </template>
        </el-table-column>
        <el-table-column :label="$t('order_manage.operation')" width="80">
          <template slot-scope="scope">
            <label
              v-if="scope.row.turnover > 0"
              style="cursor: pointer; user-select: none"
              class="font_color_green"
              @click.stop="openExpand(scope.row)"
            >
              {{ $t("order_manage.detail") }}
            </label>
          </template>
        </el-table-column>
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <div class="expand-wrap">
              <div class="clear" style="margin-bottom: 30px">
                <div class="tag">
                  {{ $t("order_manage.order_id") }}
                  <span class="ml20"> {{ scope.row.orderId }} </span>
                </div>
              </div>
              <div class="flex-wrap">
                <aside class="tag">{{ $t("order_manage.time") }}</aside>
                <aside class="tag">{{ $t("order_manage.done_price") }}</aside>
                <aside class="tag">{{ $t("order_manage.done_amount") }}</aside>
                <aside class="tag">{{ $t("order_manage.fee") }}</aside>
                <aside class="tag">{{ $t("order_manage.dk") }}</aside>
              </div>
              <div class="flex-wrap" v-for="item in scope.row.orderList">
                <section>
                  {{
                    dateFormatter(new Date(item.time), "yyyy-MM-dd hh:mm:ss")
                  }}
                </section>
                <section>{{ item.price }}</section>
                <section>{{ item.amount }}</section>
                <section>{{ item.payFee }}</section>
                <section>{{ item.payDk }}</section>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="historyTotal > 0"
        class="pagination-box"
        background
        layout="prev, pager, next"
        :total="currentTotal"
        :page-size="historyFilter.pageSize"
        :current-page="historyFilter.pageNumber"
        @current-change="pageChange2"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/components/NoData/index";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      loading1: true,
      loading2: true,
      dataShow: "current",
      currentFilter: {
        baseSymbol: "",
        coinSymbol: "",
        direction: "",
        needPage: 1,
        pageNumber: 1,
        pageSize: 8,
        priceType: "limit",
      },
      currentTotal: 0,
      historyFilter: {
        timeFilter: [],
        baseSymbol: "",
        coinSymbol: "",
        direction: "",
        needPage: 1,
        pageNumber: 1,
        pageSize: 8,
        priceType: "limit",
      },
      historyTotal: 0,
      beforeRow: null,
      beforeRowCurrent: null,
      symbolList: [],
      current_delegation: [],
      history_delegation: [],
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  created() {
    this.getAllSymbol();
    this.getCurrentDelegation();
    // this.getHistoryDelegation();
  },
  methods: {
    typeChange(val) {
      this.dataShow = val;
      this.loading = true;
      this.search();
    },
    search() {
      if (this.dataShow === "current") {
        this.currentFilter.pageNumber = 1;
        this.getCurrentDelegation();
      } else {
        this.historyFilter.pageNumber = 1;
        this.getHistoryDelegation();
      }
    },
    pageChange(val) {
      this.currentFilter.pageNumber = val;
      this.getCurrentDelegation();
    },
    pageChange2(val) {
      this.historyFilter.pageNumber = val;
      this.getHistoryDelegation();
    },
    getAllSymbol() {
      this.$axios.post("/exchangeCoin/getAll", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          //console.log(res.data.data);
          this.symbolList = res.data.data.symbolArray;
        } else {
          this.elMessage("error", res.data.msg);
        }
      });
    },
    getSearchCurrentDelegation() {
      this.currentFilter.pageNumber = 1;
      this.getCurrentDelegation();
    },
    openExpand(row) {
      if (this.beforeRow && this.beforeRow.id === row.id) {
        this.$refs.history_table.toggleRowExpansion(this.beforeRow, false); //收起之前的展开行
        this.beforeRow = null;
      } else {
        this.$refs.history_table.toggleRowExpansion(row, true);
        this.beforeRow = row;
      }
    },
    closeExpand() {
      if (this.beforeRow) {
        this.$refs.history_table.toggleRowExpansion(this.beforeRow, false); //收起之前的展开行
      }
      this.closeExpandCurrent(); //收起当前订单之前的展开行
    },
    openExpandCurrent(row) {
      if (this.beforeRowCurrent && this.beforeRowCurrent.id === row.id) {
        this.$refs.current_table.toggleRowExpansion(
          this.beforeRowCurrent,
          false,
        ); // 收起之前的展开行
        this.beforeRowCurrent = null;
      } else {
        this.$refs.current_table.toggleRowExpansion(row, true);
        this.beforeRowCurrent = row;
      }
    },
    closeExpandCurrent() {
      if (this.beforeRowCurrent) {
        this.$refs.current_table.toggleRowExpansion(
          this.beforeRowCurrent,
          false,
        ); //收起之前的展开行
      }
    },
    //获取当前委托信息
    getCurrentDelegation() {
      let param = {
        needPage: this.currentFilter.needPage,
        pageNumber: this.currentFilter.pageNumber,
        pageSize: this.currentFilter.pageSize,
        priceType: this.currentFilter.priceType,
      };
      if (this.currentFilter.coinSymbol.trim()) {
        param.coinSymbol = this.currentFilter.coinSymbol;
      }
      if (this.currentFilter.baseSymbol.trim()) {
        param.baseSymbol = this.currentFilter.baseSymbol;
      }
      if (this.currentFilter.direction.trim()) {
        param.direction = this.currentFilter.direction;
      }
      this.loading1 = true;
      this.$axios.post("/order/personal/current", param).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          //console.log(res.data.data)
          this.current_delegation = res.data.data.list;
          this.currentTotal = res.data.data.total;
          this.current_delegation.forEach((value) => {
            this.$axios
              .post("/order/tradeDetail", {
                orderId: value.orderId,
              })
              .then((res) => {
                value.orderList = res.data.data;
              });
          });
          this.loading1 = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
          this.loading1 = false;
        }
      });
    },
    getSearchHistoryDelegation() {
      this.historyFilter.pageNumber = 1;
      this.getHistoryDelegation();
    },
    //获取历史委托信息
    getHistoryDelegation() {
      let param = {
        needPage: this.historyFilter.needPage,
        pageNumber: this.historyFilter.pageNumber,
        pageSize: this.historyFilter.pageSize,
        priceType: this.historyFilter.priceType,
      };
      if (this.historyFilter.coinSymbol.trim()) {
        param.coinSymbol = this.historyFilter.coinSymbol;
      }
      if (this.historyFilter.baseSymbol.trim()) {
        param.baseSymbol = this.historyFilter.baseSymbol;
      }
      if (this.historyFilter.direction.trim()) {
        param.direction = this.historyFilter.direction;
      }
      if (this.historyFilter.timeFilter) {
        param.timeStart = this.historyFilter.timeFilter[0];
        param.timeEnd = this.historyFilter.timeFilter[1];
      }
      this.loading2 = true;
      this.$axios.post("/order/personal/history", param).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.history_delegation = res.data.data.list;
          this.historyTotal = res.data.data.total;
          this.history_delegation.forEach((value) => {
            this.$axios
              .post("/order/tradeDetail", {
                orderId: value.orderId,
              })
              .then((res) => {
                value.orderList = res.data.data;
              });
          });
          this.loading2 = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
          this.loading2 = false;
        }
      });
    },
    //取消当前委托订单
    orderCancel(row) {
      this.$axios.post("/order/getTranToken", {}).then((res) => {
        this.$axios
          .post("/order/cancel", {
            token: res.data.data.token,
            orderId: row.orderId,
            symbol: row.symbol,
          })
          .then((res) => {
            if (res.data.code === this.errorCode.ok) {
              row.statusStr = "CANCELING";
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
      });
    },
    //删除历史委托
    deleteAllCancel() {
      this.$axios.post("/order/delete", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.$message({
            type: "success",
            message: this.$t("order_manage.delete_success"),
          });
          this.getHistoryDelegation();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info-box {
  padding: 40px;
  background: #ffffff;
  border-radius: 22px 22px 22px 22px;

  .head-box {
    padding-bottom: 36px;
    border-bottom: 1px solid #e2e3e3;

    .title-box {
      gap: 40px;
      display: flex;
      margin-bottom: 24px;

      p {
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #999999;
      }

      .sel {
        font-weight: 800;
        font-size: 24px;
        color: #4063ff;
      }
    }
  }

  .btn-box {
    gap: 40px;
    display: flex;
    align-items: center;

    .btn-type1 {
      display: flex;
      align-items: center;
    }

    .btn-type2 {
      gap: 30px;
      display: flex;
      align-items: center;
      padding: 10px 9px;
      cursor: pointer;
      background: rgba(234, 235, 237, 0.5);
      border-radius: 8px 8px 8px 8px;

      .p1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #b9b9b9;
        padding-right: 40px;
      }

      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }

      i {
        font-size: 12px;
      }
    }

    .btn {
      width: 112px;
      height: 40px;
      cursor: pointer;
      text-align: center;
      line-height: 40px;
      background: #4063ff;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      border-radius: 8px 8px 8px 8px;
    }
  }

  .box2 {
    margin-top: 20px;

    /deep/.table-head {
      background: rgba(234, 235, 237, 0.5);
    }

    /deep/.table-head:first-child {
      border-radius: 6px 0px 0px 6px;
    }

    /deep/.table-head:last-child {
      border-radius: 0px 6px 6px 0px;
    }

    /deep/.table-cell {
      border: none;
    }

    /deep/ .el-table__body tr.current-row > td {
      background-color: rgba(225, 234, 255, 0.6) !important;
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: rgba(225, 234, 255, 0.6) !important;
    }

    .expand-wrap {
      border: 1px solid #d8d8d8;
      margin: 0 20px;
      padding: 20px;
      height: fit-content;
      .tag {
        color: #a0aac1;
      }

      .flex-wrap {
        display: flex;

        aside {
          flex: 1;
        }

        section {
          flex: 1;
        }
      }
    }
  }

  .width-s {
    width: 120px;
  }

  .width-s2 {
    width: 280px;
    margin-right: 20px;
  }

  /deep/ .el-range-input {
    background-color: transparent;
  }

  /deep/ .el-range-separator {
    display: flex;
    align-items: center;
  }

  .pagination-box {
    text-align: center;
    margin: 60px 0;
    /deep/ .btn-prev,
    /deep/ .btn-next,
    /deep/ .number {
      width: 44px;
      height: 44px;
      line-height: 44px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 1px rgba(180, 180, 180, 0.06);
      border-radius: 6px 6px 6px 6px;
    }

    /deep/ .active {
      background-color: #4063ff !important;
    }
  }
}
</style>
